import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // 移除了 StrictMode，避免开发环境下的重复渲染
  <ConfigProvider
    locale={zhCN}
    theme={{
      token: {
        colorPrimary: '#ff9ebb', // 使用你的主题色
        borderRadius: 8,
      },
      components: {
        Button: {
          borderRadius: 20,
        },
        Card: {
          borderRadius: 16,
        },
        Input: {
          borderRadius: 12,
        },
      },
    }}
  >
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();